import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    path: '/merchant',
    component: () => import('@/layouts/MerchantLayout.vue'),
    redirect: '/merchant/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/merchant/Dashboard.vue')
      },
      {
        path: 'tasks',
        component: () => import('@/views/merchant/tasks/List.vue')
      },
      {
        path: 'tasks/create',
        component: () => import('@/views/merchant/tasks/Create.vue')
      },
      {
        path: 'finance/transactions',
        component: () => import('@/views/merchant/finance/Transactions.vue')
      },
      {
        path: 'finance/recharge',
        component: () => import('@/views/merchant/finance/Recharge.vue')
      }
    ]
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/admin/Dashboard.vue')
      },
      {
        path: 'tasks',
        component: () => import('@/views/admin/tasks/List.vue')
      },
      {
        path: 'merchants',
        component: () => import('@/views/admin/merchants/List.vue')
      },
      {
        path: 'users',
        component: () => import('@/views/admin/users/List.vue')
      },
      {
        path: 'config/system',
        component: () => import('@/views/admin/config/System.vue')
      },
      {
        path: 'config/platforms',
        component: () => import('@/views/admin/config/Platforms.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = getToken()
  if (to.path === '/login') return next()
  if (!token) return next('/login')
  if (!store.state.user) await store.dispatch('fetchMe')
  const type = store.state.user.type
  if (to.path.startsWith('/merchant') && type !== 'merchant') return next('/admin')
  if (to.path.startsWith('/admin') && type !== 'operator') return next('/merchant')
  next()
})

export default router
